/**
 * Use a regular expression to verify whether a high five is
 * sent to a Nike employee
 *
 * @param {string} recipientEmail
 */
export function validateEmail(recipientEmail) {
  const regexEmail = /^[a-zA-Z0-9_.+-]+@nike.com$/g;
  return regexEmail.test((recipientEmail || '').toLowerCase());
}

/**
 * Compare sender email against recipient email to ensure they
 * are not equal, so that people are not sending high fives to themselves
 *
 * @param {string} senderEmail
 * @param {string} recipientEmail
 */

export function validateRecipient(senderEmail, recipientEmailList) {
  if (recipientEmailList.includes((senderEmail || '').toLowerCase())) {
    return false;
  }
  return true;
}

/**
 * Verify that all required fields have been completed, before allowing
 * users to send a high five
 *
 * @param {string} recipient
 * @param {string} recipientEmail
 * @param {string} maxim
 * @param {string} message
 */

export function isFormComplete(recipient, recipientEmail, maxim, message) {
  if (
    recipient &&
    recipientEmail &&
    maxim &&
    message
  ) {
    return true;
  }
  return false;
}



// WEBPACK FOOTER //
// ./src/lib/validation.utils.js